export class SiteLanguage {
  id: number;
  languageCode: string;
  enabled: boolean;
  createdAt: Date;
  updatedAt: Date;
}
